import { Header } from "@/components/Header";
import { Hero } from "@/components/Hero";
import { TipsSection } from "@/components/TipsSection";
import { FeaturedFundraisers } from "@/components/FeaturedFundraisers";
import { HowItWorks } from "@/components/HowItWorks";
import { CharitySection } from "@/components/CharitySection";
import { FeaturedStories } from "@/components/FeaturedStories";
import { CTA } from "@/components/CTA";
import { Footer } from "@/components/Footer";
import { CookieConsent } from "@/components/CookieConsent";
import { SEO } from "@/components/SEO";

const Index = () => {
  return (
    <div className="min-h-screen bg-background">
      <SEO
        title="FirstGiving — UK Fundraising for People & Causes"
        description="Fundraise for the people and causes you love. Start a campaign for yourself, your community, or a UK charity in minutes on FirstGiving."
        path="/"
        image="https://firstgiving.co.uk/og-image.jpg"
        jsonLd={{
          "@context": "https://schema.org",
          "@type": "Organization",
          name: "FirstGiving",
          url: "https://firstgiving.co.uk/",
          logo: "https://firstgiving.co.uk/favicon.png",
          description: "The trusted UK fundraising platform for people, communities and charities.",
          sameAs: [
            "https://twitter.com/firstgivinguk",
            "https://www.facebook.com/firstgivinguk",
            "https://www.instagram.com/firstgivinguk",
          ],
        }}
      />
      <Header />
      <main>
        <Hero />
        <TipsSection />
        <FeaturedFundraisers />
        <HowItWorks />
        <CharitySection />
        <FeaturedStories />
        <CTA />
      </main>
      <Footer />
      <CookieConsent />
    </div>
  );
};

export default Index;
